import React from 'react'

import { LntModal } from '@app/components/base'

import { CommonTemplatesForm } from './CommonTemplatesForm'

import type { CommonTemplatesModalProps } from './types'

const DEFAULT_TITLE = 'Добавление шаблона'

export const CommonTemplatesModal: React.FC<CommonTemplatesModalProps> = props => {
  const { title, onSubmit, data, ...restProps } = props

  return (
    <LntModal
      { ...restProps }
      title={ title ?? DEFAULT_TITLE }
      footer={ null }
    >
      <CommonTemplatesForm
        data={ data }
        onSubmit={ onSubmit }
      />
    </LntModal>
  )
}
